import { NgModule } from '@angular/core';
import { OpenZenDeskDirective } from './open-zendesk.directive';

@NgModule({
  imports: [],
  declarations: [OpenZenDeskDirective],
  exports: [OpenZenDeskDirective],
})
export class OpenZenDeskModule {}
